module.exports = __webpack_public_path__ + "img/message.3140e20a.svg";